import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { catchError, takeUntil } from "rxjs/operators";

import { UserService } from "../shared/user.service";
import { SnackBarService } from "../../core/snack-bar.service";

import { UserListing } from "../shared/user-listing.model";

@Component({
    template: require('./user-list.component.html'),
    styles: [require('./user-list.component.css')]
})
export class UserListComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns = ["username", "fullName", "isWebAdmin", "isActive", "isLocked", "actions"];
    filterFC: FormControl;
    loading: boolean;
    userDataSource: MatTableDataSource<UserListing>;

    private ngUnsubscribe: Subject<void> = new Subject(); //see https://stackoverflow.com/a/41177163

    constructor(
        private userService: UserService,
        private router: Router,
        private snackBarService: SnackBarService) {

        this.filterFC = new FormControl();
        this.userDataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.filterFC.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(val => {
                this.userDataSource.filter = val;
            });

        this.loading = true;
        this.userService.getListing()
            .then(data => {
                this.loading = false;
                this.userDataSource.data = data;
            })
            .catch(err => {
                this.loading = false;
                this.snackBarService.openSnackBar(err);
            });
    }

    ngAfterViewInit() {
        this.userDataSource.sort = this.sort;
        this.userDataSource.paginator = this.paginator;
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    goToUser(userID: number): void {
        this.router.navigate(["/users", userID]);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/admin/user-list/user-list.component.ts